import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.prototype.axios = axios;

// set ElementUI lang to EN
// Vue.use(ElementUI, { locale })
// 如果想使用中文版，按以下声明
Vue.use(ElementUI)

// 跨组件通信 全局事件总线
Vue.prototype.$bus = new Vue(); // 安装总线



Vue.config.productionTip = false;
Vue.prototype.$getViewportSize = function() {
  return {
    width: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
    height: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
  }
}
//  ============ 发布项目清除缓存  以下  ===========================
const VUE_APP_VERSION = require('../package.json').version
const vers = window.localStorage.getItem("appVersion");
if(VUE_APP_VERSION != vers){
  // localStorage.clear()
  window.localStorage.setItem("appVersion", VUE_APP_VERSION);
  window.location.reload(true);
}
//  ============ 发布项目清除缓存  以上  ===========================
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
